import * as R from 'ramda';
import { createSelector } from 'reselect';
// helpers/constants
import * as GC from '../../constants';
//////////////////////////////////////////////////

const store = ({ fleetDocuments }) => fleetDocuments;

const makeSelectUsedReport = () => createSelector(
  store,
  (state) => {
    const { reportType } = state;

    return R.path([reportType, 'usedReport'], state);
  },
);

const makeSelectAvailableReports = () => createSelector(
  store,
  (state) => {
    const { reportType } = state;

    return R.path([reportType, 'availableReports'], state);
  },
);

const makeSelectPagination = () => createSelector(
  store,
  (state) => {
    const { reportType } = state;

    return R.path([reportType, 'pagination'], state);
  },
);

const makeSelectReportType = () => createSelector(
  store,
  ({ reportType }) => reportType,
);

const makeSelectItemList = () => createSelector(
  store,
  (state) => {
    const { reportType } = state;

    return R.compose(
      R.sortBy(R.prop('index')),
      R.values,
      R.pathOr({}, [reportType, 'itemList']),
    )(state);
  },
);

const makeSelectTotalCount = () => createSelector(
  store,
  (state) => {
    const { reportType } = state;

    return R.path([reportType, 'totalCount'], state);
  },
);

const makeSelectListLoading = () => createSelector(
  store,
  (state) => {
    const { reportType } = state;

    return R.path([reportType, 'loading'], state);
  },
);

const makeSelectReportStatus = () => createSelector(
  store,
  (state) => {
    const { reportType } = state;

    return R.path([reportType, 'reportPending'], state);
  },
);

const makeSelectTableTitleFilters = () => createSelector(
  store,
  (state) => {
    const { reportType } = state;

    return R.path([reportType, 'tableTitleFilters'], state);
  },
);

const makeSelectTitleSortValues = () => createSelector(
  store,
  (state) => {
    const { reportType } = state;

    return R.path([reportType, 'titleSortValues'], state);
  },
);

const makeSelectFilterParams = () => createSelector(
  store,
  (state) => {
    const { reportType } = state;

    return R.path([reportType, 'filterParams'], state);
  },
);

const makeSelectPageVisited = () => createSelector(
  store,
  (state) => {
    const { reportType } = state;

    return R.path([reportType, 'pageVisited'], state);
  },
);

const makeSelectSummary = () => createSelector(
  store,
  (state) => {
    const { reportType } = state;

    return R.pathOr({}, [reportType, 'summary'], state);
  },
);

const makeSelectSummaryFilter = () => createSelector(
  store,
  (state) => {
    const { reportType } = state;

    return R.path([reportType, 'tableTitleFilters', GC.FIELD_EXPIRATION_STATUS], state);
  },
);

export {
  makeSelectSummary,
  makeSelectItemList,
  makeSelectUsedReport,
  makeSelectPagination,
  makeSelectTotalCount,
  makeSelectReportType,
  makeSelectListLoading,
  makeSelectPageVisited,
  makeSelectFilterParams,
  makeSelectReportStatus,
  makeSelectSummaryFilter,
  makeSelectTitleSortValues,
  makeSelectAvailableReports,
  makeSelectTableTitleFilters,
};
